import { Navigate, useLocation } from 'react-router-dom';

import { appPaths } from '@/app/router/paths.js';

export function RedirectLegacyDesignSystem() {
  const { hash } = useLocation();
  return <Navigate to={`${appPaths.harnessDesignSystem}${hash}`} replace />;
}
